import { ControlFieldMapping } from './ControlFieldMapping';

export class SimpleFormFlowField {
    ParentPropertyName: string;
    DisplayName: string;
    StepId: string;
    ParentMultiPropertyName: string;
    FieldType: string;
    Mappings: ControlFieldMapping[];
}
